import script from "./ManageUsersTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageUsersTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./ManageUsersTableLoader.vue?vue&type=style&index=0&id=22fb4e52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fb4e52"]])

export default __exports__